/* eslint-disable */
export default {
  order: 5,
  header: [],
  content: [
    {
      category: '2.3 Release Notes (2021/12/30)',
      description: 'Check out EnOS release notes.',
      image: '',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS™ Cloud 2.3 Cumulative Updates',
          description: 'A cumulative update is a quarterly update that includes new features, enhancements, and issue fixes.',
          image: '',
          list: [
              {
              name: '2.3 Cumulative Update 5',
              url: '/docs/enos/en/2.3.0/releasenotes/cu5.html'
              },
              {
                name: '2.3 Cumulative Update 4',
                url: '/docs/enos/en/2.3.0/releasenotes/cu4.html'
                },
              {   
              name: '2.3 Cumulative Update 3',
              url: '/docs/enos/en/2.3.0/releasenotes/cu3.html'
              },
              {
              name: '2.3 Cumulative Update 2',
              url: '/docs/enos/en/2.3.0/releasenotes/cu2.html'
              },
              {
              name: '2.3 Cumulative Update 1',
              url: '/docs/enos/en/2.3.0/releasenotes/cu1.html'
              }
              ]
            },
            {
              name: 'EnOS™ Cloud 2.3',
              description: '',
              image: '',
              list: [
                {
                  name: 'What’s New?',
                  url: '/docs/enos/en/2.3.0/releasenotes/new_feature.html'
                },
                {
                  name: 'What’s Changed?',
                  url: '/docs/enos/en/2.3.0/releasenotes/enhancement.html'
                },
                {
                  name: 'Deprecations and Removals',
                  url: '/docs/enos/en/2.3.0/releasenotes/deprecated.html'
                },
                {
                  name: 'Known Issues and Limitations',
                  url: '/docs/enos/en/2.3.0/releasenotes/knownissue.html'
                }
              ]
            },            
            
        {
          name: 'EnOS™ Edge 2.3',
          description: '',
          image: '',
          list: [
            {
              name: 'What’s New?',
              url: '/docs/enos-edge/en/2.3.0/releasenotes/new_feature.html'
            },
            {
              name: 'What’s Changed?',
              url: '/docs/enos-edge/en/2.3.0/releasenotes/enhanced_feature.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS Fundamental',
      description: 'EnOS, an AIoT operating system from Univers that is missioned to enable enterprises and cities to accelerate digital transformation and ecosystem development.  ',
      image: '',
      url: '/docs/enos/en/2.3.0/overview/enos_introduction.html',
      item: [
        {
          name: 'Getting Started',
          description: 'Learn about the advantages and key concepts of EnOS and get started with EnOS quickly.',
          image: '',
          list: [
            {
              name: 'What Is EnOS',
              url: '/docs/enos/en/2.3.0/overview/enos_introduction.html'
            },
            {
              name: 'Getting Started with EnOS',
              url: '/docs/enos/en/2.3.0/getting_started_with_enos/getting_started_with_enos.html'
            },
            {
              name: 'Frequently Asked Questions',
              url: '/docs/enos/en/2.3.0/faq/index.html'
            }
          ]
        },
        {
          name: 'EnOS™ Management Console',
          description: 'An all-in-one GUI console where IoT engineers, data scientists, and application developers can seamlessly manage the entire IoT life cycle, from device connection, data analysis, to application management and more.',
          image: '',
          list: [
            {
              name: 'Accessing EnOS',
              url: '/docs/enos/en/2.3.0/overview/accessing_enos.html'
            },
            {
              name: 'About the EnOS Management Console',
              url: '/docs/enos/en/2.3.0/overview/enos_console_overview.html'
            },
            {
              name: 'EnOS Management Console GUI Conventions',
              url: '/docs/enos/en/2.3.0/overview/ui_conventions.html'
            }
          ]
        },
        {
          name: 'Identity and Access Management',
          description: 'Provides user account life cycle management capabilities, where you can control access to resources managed through EnOS. You can centralize the management of user identities and permissions, thereby ensuring the security of your organization’s data.',
          image: '',
          list: [
            {
              name: 'IAM Overview',
              url: '/docs/enos/en/2.3.0/iam/iam_overview.html'
            },
            {
              name: 'Concepts',
              url: '/docs/enos/en/2.3.0/iam/concept/index.html'
            },
            {
              name: 'LDAP Federation',
              url: '/docs/enos/en/2.3.0/iam/ou_admin/ldap/index.html'
            }
          ]
        },
        {
          name: 'Resource Management',
          description: 'Provides on-demand management of your resource usages, where you can configure alarms based on resource usages, thereby improving the transparency and utilization of resources.',
          image: '',
          list: [
            {
              name: 'Resource Management on EnOS',
              url: '/docs/enos/en/2.3.0/resourcemanagement/overview.html'
            },
            {
              name: 'Resource Specifications',
              url: '/docs/enos/en/2.3.0/resourcemanagement/reference/index.html'
            },
            {
              name: 'Requesting for Resources',
              url: '/docs/enos/en/2.3.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: 'Metering Service',
          description: 'Provides multi-dimensional visualization of measurement data that is used by platform resources and services, enabling platform operators to evaluate the operational status of the platform and develop better operations strategy based on the data.',
          image: '',
          list: [
            {
              name: 'About Metering Service',
              url: '/docs/enos/en/2.3.0/metering/metering_overview.html'
            }
          ]
        },
        {
          name: 'Audit Service',
          description: 'Supports auditing and monitoring of all user operations, user logins, and user logouts, and storing them as historical events in a traceable and unalterable format during the storage period. This helps to enforce data security and compliance for your organization.',
          image: '',
          list: [
            {
              name: 'About Audit',
              url: '/docs/enos/en/2.3.0/audit/audit_overview.html'
            }
          ]
        },
        {
          name: 'Application Registration',
          description: 'Provides convenient management of applications, where application developers can register, purchase, modify, or export applications.',
          image: '',
          list: [
            {
              name: 'Registering and Managing Applications',
              url: '/docs/app-development/en/2.3.0/app_management/managing_apps.html'
            }
          ]
        },
        {
          name: 'EnOS™ API',
          description: 'APIs and API references are available for all EnOS core business processes, helping to expedite application development and access to system resources.',
          image: '',
          list: [
            {
              name: 'About EnOS API',
              url: '/docs/api/en/2.3.0/overview.html'
            },
            {
              name: 'API Authentication',
              url: '/docs/api/en/2.3.0/authen_overview.html'
            },
            {
              name: 'Get Started with EnOS API',
              url: '/docs/api/en/2.3.0/gettingstarted.html'
            },
            {
              name: 'API Reference',
              url: '/docs/api/en/2.3.0/api_reference.html'
            }
          ]
        },
        {
          name: 'Security',
          description: 'Learn about the security technologies built in EnOS.',
          image: '',
          list: [
            {
              name: 'Security Overview',
              url: '/docs/enos/en/2.3.0/security/security_overview.html'
            },
            {
              name: 'X.509 Certificate Service',
              url: '/docs/enos/en/2.3.0/security/x509_ca/index.html'
            },
            {
              name: 'Identity & Access Management',
              url: '/docs/enos/en/2.3.0/iam/iam_overview.html'
            }
          ]
        },
        {
          name: 'Data Source Registration',
          description: 'Enables centralized registration of internal EnOS data sources and external data sources, so that related product modules can directly access these data sources.',
          image: '',
          list: [
            {
              name: 'Data Source Registration Overview',
              url: '/docs/data-source-reg/en/2.3.0/datasource_overview.html'
            },
            {
              name: 'Registering Data Sources',
              url: '/docs/data-source-reg/en/2.3.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'EnOS Edge',
      description: 'EnOS™ Edge is an intelligent software-defined IoT gateway and edge computing platform that adapts to heterogeneous devices and systems in the physical world and enables cost-effective IoT connectivity, edge computing, local control and optimization solutions.',
      image: 'assets/images/EnOS Edge_LIght.png',
      url: '/docs/enos-edge/en/2.3.0/edge_overview.html',
      item: [
        {
          name: 'EnOS™ Edge User Guide',
          description: 'EnOS Edge adapts and accelerates connection through its built-in protocol library. Moreover, it extends cloud intelligence to the edge by providing edge computing and local control to accelerate decision-making and actions.',
          image: 'assets/images/edge/user.png',
          list: [
            {
              name: 'EnOS Edge Overview',
              url: '/docs/enos-edge/en/2.3.0/edge_overview.html'
            },
            {
              name: 'Edge Device Connection Tutorial',
              url: '/docs/enos-edge/en/2.3.0/tutorial/connecting_edge.html'
            },
            {
              name: 'API Reference',
              url: '/docs/edge-api/en/2.3.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'IoT Hub',
      description: 'Provides extensive, secure, and fast connection to heterogeneous sensors, devices, and systems, and device life cycle management.',
      image: 'assets/images/IoT Hub_LIght.png',
      url: '/docs/dcm/en/2.3.0/iot_hub_overview.html',
      item: [
        {
          name: 'Device Connectivity & Management Service',
          description: 'Rapidly access and manage the real-time or historical data of a vast number of diverse devices or systems. The built-in digital twin model library helps to expedite the digital abstraction of industry devices. Manage the entire device life cycle and set up dynamic alert triggers to reduce response time for device anomalies and faults.',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: 'Device Connectivity Service Overview',
              url: '/docs/device-connection/en/2.3.0/device_management_overview.html'
            },
            {
              name: 'Device Modeling',
              url: '/docs/device-connection/en/2.3.0/howto/model/index.html'
            },
            {
              name: 'Alert Management',
              url: '/docs/alert/en/2.3.0/learn/alert_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/device-connection/en/2.3.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'API Reference',
              url: '/docs/device-connection/en/2.3.0/reference/api_reference'
            }
          ]
        },
        {
          name: 'Device Integration Service',
          description: 'The low-code and intuitive drag-and-drop flow designer helps to accelerate the device integration process. You can also monitor the processes and set up alert notifications to reduce operation costs.',
          image: 'assets/images/iothub/Integration.png',
          list: [
            {
              name: 'Device Integration Service Overview',
              url: '/docs/device-integration/en/2.3.0/learn/device_integration_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/device-integration/en/2.3.0/howto/gettingstarted_storing_data'
            },
            {
              name: 'Node Reference',
              url: '/docs/device-integration/en/2.3.0/reference/index_nodes.html'
            }
          ]
        }
      ]
    },

    {
      category: 'Enterprise Data Platform',
      image: 'assets/images/Enterprise Data Platform_LIght.png',
      description: 'Explore the value of data assets, reduce your cost of massive IoT data ownership, and realize the efficient management of device asset data.',
      url: '/docs/data-asset/en/2.3.0/data_asset_overview.html',
      item: [
        {
          name: 'Data Catalog',
          description: 'Provides a unified management of massive amount of data from multiple sources and implements data modelling and data standards to realize efficient data discovery, unlocking data value and helping business users to understand enterprise data assets easily.',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: 'Data Catalog Overview',
              url: '/docs/data-asset-catalog/en/2.3.0/data_catalog_intro.html'
            },
            {
              name: 'Quickstart',
              url: '/docs/data-asset-catalog/en/2.3.0/data_catalog_quickstart.html'
            },
            {
              name: 'Syncing Data Assets',
              url: '/docs/data-asset-catalog/en/2.3.0/howto/data_sync.html'
            },
            {
              name: 'Managing Data Objects',
              url: '/docs/data-asset-catalog/en/2.3.0/howto/data_management.html'
            }
          ]
        },
        {
          name: 'Stream Processing',
          description: 'With the library of common calculators and templates that are accumulated from typical computing scenarios, you can easily develop stream processing and analysis pipelines in a low-code and intuitive drag-and-drop designer.',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: 'Stream Processing Overview',
              url: '/docs/stream-processing/en/2.3.0/streaming_overview.html'
            },
            {
              name: 'Developing Stream Processing Pipelines',
              url: '/docs/stream-processing/en/2.3.0/dev.html'
            },
            {
              name: 'Stream Processing Pipeline Operation',
              url: '/docs/stream-processing/en/2.3.0/ops.html'
            },
            {
              name: 'API Reference',
              url: '/docs/stream-processing-api/en/2.3.0/overview.html'
            }
          ]
        },
        {
          name: 'Time Series Data Management',
          description: 'A high throughput, high availability, and high compression storage for massive IoT time series data.  The efficient query APIs and visualization tools help you identify and gain insights into your data.',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: 'Time Series Data Management Overview',
              url: '/docs/time-series-data/en/2.3.0/overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/time-series-data/en/2.3.0/getting_started.html'
            },
            {
              name: 'Storage Policy for EnOS Cloud Users',
              url: '/docs/time-series-data/en/2.3.0/cloudpolicy/policy.html'
            },
            {
              name: 'Storage Policy for EnOS Edge Users',
              url: '/docs/time-series-data/en/2.3.0/edgepolicy/policy.html'
            },
            {
              name: 'API Reference',
              url: '/docs/time-series-data/en/2.3.0/reference/api.html'
            }
          ]
        },
        {
          name: 'Data Federation',
          description: 'A unified data access layer built on top of multi-source heterogeneous data storage systems without moving or synchronizing data. With Data Federation, different data consumers can access data rapidly by using the standard query methods, such as SQL, JDBC, or OData.',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: 'Data Federation Overview',
              url: '/docs/data-federation/en/2.3.0/data_federation_overview.html'
            },
            {
              name: 'Channel Management',
              url: '/docs/data-federation/en/2.3.0/channel_management.html'
            },
            {
              name: 'Data Read and Write',
              url: '/docs/data-federation/en/2.3.0/data_rw.html'
            },
            {
              name: 'API Reference',
              url: '/docs/data-federation-api/en/2.3.0/overview.html'
            }
          ]
        },
        {
          name: 'Data Subscription',
          description: 'Data subscriptions enable you to push data to applications in real time, improving the efficiency of data acquisition and consumption. Use the SDK provided to enable your applications to subscribe to data efficiently.',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: 'Data Subscription Overview',
              url: '/docs/data-subscription/en/2.3.0/data_subscription_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/data-subscription/en/2.3.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: 'Consuming Subscribed Data for EnOS Cloud Users',
              url: '/docs/data-subscription/en/2.3.0/consuming_subscribed_data.html'
            },
            {
              name: 'Consuming Subscribed Data for EnOS Edge Users',
              url: '/docs/data-subscription/en/2.3.0/consuming_subscribed_data_edge.html'
            },
            {
              name: 'Data Subscription SDK Reference',
              url: '/docs/data-subscription/en/2.3.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: 'Data Archiving',
          description: 'Massive data archiving is performed periodically to ensure that cold data, which is less frequently accessed and takes up a huge amount of storage, is stored in a more economical manner.',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: 'Data Archiving Overview',
              url: '/docs/data-archiving/en/2.3.0/archive_policy.html'
            },
            {
              name: 'Configuring Data Archiving Jobs',
              url: '/docs/data-archiving/en/2.3.0/configuring_archive_storage.html'
            },
            {
              name: 'Data Archiving Logic',
              url: '/docs/data-archiving/en/2.3.0/archive_storage.html'
            }
          ]
        },
        {
          name: 'Data Synchronization',
          description: 'Establish the data transmission channel between external databases and EnOS internal databases to achieve the centralized synchronization and sharing of data and files.',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: 'Data Synchronization Overview',
              url: '/docs/data-sync/en/2.3.0/di_overview.html'
            },
            {
              name: 'Synchronizing Data from External Data Source to Hive',
              url: '/docs/data-sync/en/2.3.0/creating_scratch_onetime.html'
            },
            {
              name: 'Synchronizing Data From EnOS Hive to the Target Database',
              url: '/docs/data-sync/en/2.3.0/creating_scratch_hive2mysql.html'
            }
          ]
        },
        {
          name: 'Batch Processing',
          description: 'Enables data developers to process large amounts of data through a visual workflow designer and the stable scheduling service. You can perform calculations, analysis, and gain insights into your data based on data lakes, data warehouses, and application data.',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: 'Batch Processing Overview​',
              url: '/docs/batch-processing/en/2.3.0/dataide_overview.html'
            },
            {
              name: 'Task Resource Management',
              url: '/docs/batch-processing/en/2.3.0/job_resource/index.html'
            },
            {
              name: 'Workflow Development',
              url: '/docs/batch-processing/en/2.3.0/data_dev/index.html'
            },
            {
              name: 'Workflow Operation',
              url: '/docs/batch-processing/en/2.3.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: 'Data Asset Authorization (Preview)',
          description: 'Data Asset Authorization provides centralized management of access rights of data assets to improve security',
          image: '',
          list: [
            {
              name: 'Data Asset Authorization Overview​',
              url: '/docs/data-asset-auth/en/2.3.0/data_asset_permission.html'
            },
            {
              name: 'Managing Permission Policy',
              url: '/docs/data-asset-auth/en/2.3.0/managing_permission_policy.html'
            }
          ]
        },
        {
          name: 'Metric Management（Preview）',
          description: 'Build a unified metric system, establish data standards, and realize the full lifecycle management of metric data.',
          image: '',
          list: [
            {
              name: 'Metric Management​ Overview',
              url: '/docs/metric-management/en/preview/overview/metrics_overview.html'
            },
            {
              name: 'Key Concept',
              url: '/docs/metric-management/en/preview/overview/metrics_concept.html'
            }
          ]
        }
      ]
    },

    {
      category: 'Enterprise Analytics Platform',
      image: 'assets/images/Enterprise Analytics Platform_LIght.png',
      description: 'Based on Enterprise Data Platform and data lake, integrate data in multiple systems to unlock business insights.',
      url: '/docs/ai-analytics/en/2.3.0/ai_analytics_overview.html',
      item: [
        {
          name: 'Dataset Management',
          description: 'Datasets can help data scientists access data quickly when developing algorithm and training models. They do not need to care about how to connect data sources and the differences of data access paths of various data sources, so as to improve their work efficiency.',
          image: 'assets/images/eap/Dataset_Management.png',
          list: [
            {
              name: 'Dataset Management Overview',
              url: '/docs/ai-analytics/en/2.3.0/dataset_management/dataset_overview.html'
            },
            {
              name: 'Creating a Dataset',
              url: '/docs/ai-analytics/en/2.3.0/dataset_management/creating_dataset.html'
            },
            {
              name: 'Managing Datasets',
              url: '/docs/ai-analytics/en/2.3.0/dataset_management/managing_dataset.html'
            },
            {
              name: 'Exploring Datasets',
              url: '/docs/ai-analytics/en/2.3.0/dataset_management/exploring_dataset.html'
            }
          ]
        },
        {
          name: 'MI Lab',
          description: 'With MI Lab, a model development environment that is integrated with the mainstream Jupyter Lab and MLflow, you can package machine learning models in diversified formats, perform visual comparison and selection of models, collaborate and share examples on-demand, and shorten the training cycle of complex models.',
          image: 'assets/images/eap/MI_Lab.png',
          list: [
            {
              name: 'MI Lab Overview',
              url: '/docs/ai-analytics/en/2.3.0/mi_lab/mi_lab_overview.html'
            },
            {
              name: 'Managing Notebook Instances',
              url: '/docs/ai-analytics/en/2.3.0/mi_lab/managing_notebook.html'
            },
            {
              name: 'Managing Model Code',
              url: '/docs/ai-analytics/en/2.3.0/mi_lab/integrating_with_git.html'
            },
            {
              name: 'Monitoring Notebook Instances',
              url: '/docs/ai-analytics/en/2.3.0/mi_lab/integrating_with_mlflow.html'
            }
          ]
        },
        {
          name: 'MI Hub',
          description: 'As a distribution center for AI assets, MI Hub provides a comprehensive AI asset registration, hosting, and versioning service for model developers. Cloud deployment is also supported, facilitating the efficient management of AI assets, and improving the overall efficiency of model engineering.',
          image: 'assets/images/eap/MI_Hub.png',
          list: [
            {
              name: 'MI Hub Overview',
              url: '/docs/ai-analytics/en/2.3.0/mi_hub/mi_hub_overview.html'
            },
            {
              name: 'Registering Models',
              url: '/docs/ai-analytics/en/2.3.0/mi_hub/registering_model.html'
            },
            {
              name: 'Deploying and Calling Model Service',
              url: '/docs/ai-analytics/en/2.3.0/mi_hub/version_deployment.html'
            },
            {
              name: 'Monitoring Model Production Indicators',
              url: '/docs/ai-analytics/en/2.3.0/mi_hub/monitoring_indicator.html'
            }
          ]
        },
        {
          name: 'MI Pipelines',
          description: 'Achieve end-to-end AI model life cycle management by designing and monitoring pipeline flows that automate the online deployment of machine learning algorithms. You can design a variety of machine learning task nodes according to your business needs, forming a closed-loop and continual machine learning deployment.',
          image: 'assets/images/eap/MI_Pipelines.png',
          list: [
            {
              name: 'MI Pipelines Overview',
              url: '/docs/ai-analytics/en/2.3.0/mi_pipelines/mi_pipeline_overview.html'
            },
            {
              name: 'Managing Workflows',
              url: '/docs/ai-analytics/en/2.3.0/mi_pipelines/creating_workflow.html'
            },
            {
              name: 'Developing and Managing Workflows',
              url: '/docs/ai-analytics/en/2.3.0/mi_pipelines/developing_model.html'
            },
            {
              name: 'Operator Reference',
              url: '/docs/ai-analytics/en/2.3.0/mi_pipelines/calculator.html'
            }
          ]
        },
        {
          name: 'Resource Configuration',
          description: 'Provides centralized management of the configurations of computing resources, storage resources and the connections. It provides the fundamental connections and resources for services on the Enterprise Analytics Platform, such as MI Lab, MI Hub, MI Pipelines, to facilitate the quick configuration of resources based on your needs for machine learning.',
          image: 'assets/images/eap/Resource_Configuration.png',
          list: [
            {
              name: 'Resource Configuration Overview',
              url: '/docs/ai-analytics/en/2.3.0/resource_configuration/resource_configuration_overview.html'
            },
            {
              name: 'Managing Storage',
              url: '/docs/ai-analytics/en/2.3.0/resource_configuration/managing_storage.html'
            },
            {
              name: 'Configuring Data Source Connection',
              url: '/docs/ai-analytics/en/2.3.0/resource_configuration/configuring_connection.html'
            }
          ]
        }
      ]
    },

    {
      category: 'Application Enablement Platform',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: 'Provides components, libraries, and services for application development, helping you to build, deploy, and extend applications easily.',
      url: '/docs/app-development/en/2.3.0/app_dev_overview.html',
      item: [
        {
          name: 'Application Development Basics',
          description: 'Based on the application development services and widgets provided by EnOS, quickly start application design, development, deployment, and hosting.',
          image: 'assets/images/aep/Application_Development_Basics.png',
          list: [
            {
              name: 'Registering and Managing Applications',
              url: '/docs/app-development/en/2.3.0/app_management/managing_apps.html'
            },
            {
              name: 'Using EnOS SDKs to Develop',
              url: '/docs/app-development/en/2.3.0/sdk_overview.html'
            },
            {
              name: 'Developing and Publishing APIs',
              url: '/docs/apim/en/2.3.0/api_management_overview.html'
            }
          ]
        },
        {
          name: 'Application Portal',
          description: 'Integrated with EnOS services and data, Application Portal is a web and mobile responsive application framework that helps you to achieve centralized management of application users and access, thereby reducing application development cost and delivering an integrated experience across applications.',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: 'About the Application Portal',
              url: '/docs/app-portal/en/2.3.0/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/app-portal/en/2.3.0/concept.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/app-portal/en/2.3.0/start/setting_up_app_portal.html'
            },
            {
              name: 'Application Portal APIs',
              url: '/docs/app-portal-api/en/2.3.0/overview.html'
            }
          ]
        },
        {
          name: 'Digital Twin Visualization',
          description: 'The built-in rich graphic components and low-code platform make it easy for you to build visual applications. You can use a combination of 2D and 3D technologies to enhance the user experience of your monitoring and operation applications.',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: 'Digital Twin Visualization Overview',
              url: '/docs/dtv/en/2.3.0/overview.html'
            },
            {
              name: 'Creating Projects and Pages',
              url: '/docs/dtv/en/2.3.0/building_dashboard/creating_projects_pages.html'
            },
            {
              name: 'Widgets',
              url: '/docs/dtv/en/2.3.0/reference/widgets/index.html'
            }
          ]
        },
        {
          name: 'Business Process Management',
          description: 'The flexible orchestration and cross-system integration capabilities of BPM enables you to integrate your applications and digitalize your business processes rapidly. You can manage and design process life cycles through a low-code and visual process modeler.',
          image: 'assets/images/aep/Business_Process_Management.png',
          list: [
            {
              name: 'About Business Process Management',
              url: '/docs/bpm/en/2.3.0/overview.html'
            },
            {
              name: 'Building Process Models',
              url: '/docs/bpm/en/2.3.0/process_owner/building_process_models.html'
            },
            {
              name: 'Process Elements',
              url: '/docs/bpm/en/2.3.0/reference/process/index.html'
            },
            {
              name: 'Form Elements',
              url: '/docs/bpm/en/2.3.0/reference/form/index.html'
            }
          ]
        },
        {
          name: 'Notification Management (Preview)',
          description: 'Provides an SMS and email push notification service for EnOS services and applications that are developed on EnOS. This service helps you to centralize the management of all push notifications, improve the reach and delivery of push notifications, and enforce secure push channels. Quota and metering services are also available to help optimize allocation of your resources.',
          image: 'assets/images/aep/Notification_Management.png',
          list: [
            {
              name: 'Notification Management Overview',
              url: '/docs/notification-mgmt/en/2.3.0/notification_center_overview.html'
            },
            {
              name: 'Basic Concepts',
              url: '/docs/notification-mgmt/en/2.3.0/notification_center_concepts.html'
            },
            {
              name: 'Quick Start: Deploy and Configure the Notification Management Service',
              url: '/docs/notification-mgmt/en/2.3.0/notification_gettingstarted.html'
            }
          ]
        },
        {
          name: 'API Management',
          description: 'Provides secured API life cycle management capabilities to help you grow your business quickly through API integrations.',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'About API Management',
              url: '/docs/apim/en/2.3.0/api_management_overview.html'
            },
            {
              name: 'API Lifecycle Management',
              url: '/docs/apim/en/2.3.0/api_lifecycle_management.html'
            },
            {
              name: 'EnOS APIM Security',
              url: '/docs/apim/en/2.3.0/apim_security.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/apim/en/2.3.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: 'Developer Studio',
          description: 'Built on DevOps best practices, the Developer Studio offers a compilation of the best tools to help simplify the application development, deployment, maintenance, and scaling process, thereby enabling efficient and seamless collaboration among application developers and operators.',
          image: 'assets/images/aep/Developer_Studio.png',
          list: [
            {
              name: 'Managing OU and Projects',
              url: '/docs/ecp/en/2.3.0/howto/developerstudio/ou_project_app/ou_project_app.html'
            },
            {
              name: 'Managing Pipelines',
              url: '/docs/ecp/en/2.3.0/howto/devops/pipeline/creating_pipeline.html'
            },
            {
              name: 'Publishing Applications',
              url: '/docs/ecp/en/2.3.0/howto/devops/publishing_app/publishing_app.html'
            }
          ]
        },
        {
          name: 'App Hub',
          description: 'Based on Helm Charts, common and reusable components and services can be deployed as templates in just a few clicks.',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: 'Managing Application Templates',
              url: '/docs/ecp/en/2.3.0/howto/app_hub/managing_app_template.html'
            },
            {
              name: 'Deploying Application Instances',
              url: '/docs/ecp/en/2.3.0/howto/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: 'Serverless Service',
          description: 'An event-driven function computing service, where resources are allocated and scheduled on a function-level basis so that functions can run in a flexible and reliable manner, thereby enabling you to focus on the business logic of your applications during development.',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: 'Serverless Service Overview',
              url: '/docs/ecp/en/2.3.0/howto/serverless/serverless_overview.html'
            },
            {
              name: 'Publishing a Function Application',
              url: '/docs/ecp/en/2.3.0/howto/serverless/managing_function.html'
            }
          ]
        },
        {
          name: 'Single Sign-On Service',
          description: 'Implement a single sign-on service between EnOS and third-party applications by using mainstream standard protocols, solving the problem of having different identity authentication methods for different business applications of your organization.',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: 'About Single Sign-On',
              url: '/docs/sso/en/2.3.0/sso_overview.html'
            },
            {
              name: 'Basic Concepts',
              url: '/docs/sso/en/2.3.0/sso_concept.html'
            }
          ]
        },
        {
          name: 'EnOS™ HMI',
          description: 'The rich industry graphic component library helps to accelerate the building of asset data visualization and industrial monitoring applications. ',
          image: 'assets/images/aep/EnOS_HMI.png',
          list: [
            {
              name: 'About EnOS HMI',
              url: '/docs/app-development/en/2.3.0/hmi/hmi_overview.html'
            },
            {
              name: 'Deploying and Previewing Monitoring Page',
              url: '/docs/app-development/en/2.3.0/hmi/deploying_graph.html'
            }
          ]
        }
      ]
    }
  ]
};
